import script from "./StoreManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreManagement.vue?vue&type=script&setup=true&lang=js"

import "./StoreManagement.vue?vue&type=style&index=0&id=54211300&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54211300"]])

export default __exports__